/**
 * Business Page
 * 事業内容 - 3つの事業セクション、会社での取り組み
 */

const Business = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Page Header */}
      <section className="bg-gradient-to-br from-gray-50 via-white to-gray-50 py-20 border-b border-gray-200">
        <div className="container-custom">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-fade-in text-rs-gray-dark">
            事業内容
          </h1>
          <p className="text-xl text-gray-500 animate-slide-up">
            WHAT WE DO
          </p>
        </div>
      </section>

      {/* 事業概要 */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-rs-gray-dark">
              <span className="text-rs-orange">通信事業</span>
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              家電量販店や催事場、商業施設などの各種イベント会場で、大手キャリアの販売促進を行なっています。
            </p>
          </div>

          {/* 事業内容 */}
          <div className="max-w-3xl mx-auto">
            <div className="bg-white border border-gray-200 rounded-2xl p-10">
              <ul className="space-y-4 text-gray-700 text-lg">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-rs-orange mt-1 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  お客様へのニーズや生活スタイルに合わせた商品・サービスの提案
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-rs-orange mt-1 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  契約手続きのサポート
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-rs-orange mt-1 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  イベント運営補助
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 会社での取り組み */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-rs-gray-dark">
            会社での<span className="text-rs-orange">取り組み</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            <div className="bg-white border border-gray-200 p-6 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <h3 className="text-lg font-bold mb-3 text-rs-gray-dark">
                充実した研修制度
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                未経験の方でも安心してスタートできるよう、基礎から実践まで
                段階的に学べる研修プログラムを用意しています。
                先輩社員がマンツーマンでサポートします。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <h3 className="text-lg font-bold mb-3 text-rs-gray-dark">
                目標達成支援
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                個人の目標設定から達成までを丁寧にサポート。
                定期的な1on1ミーティングで、成長をしっかりとバックアップします。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <h3 className="text-lg font-bold mb-3 text-rs-gray-dark">
                キャリアアップ制度
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                頑張りを正当に評価し、昇給・昇格のチャンスが豊富にあります。
                スタッフからリーダー、マネージャーへとステップアップできます。
              </p>
            </div>

            <div className="bg-white border border-gray-200 p-6 rounded-2xl hover:shadow-lg hover:border-rs-orange/30 transition-all duration-300">
              <h3 className="text-lg font-bold mb-3 text-rs-gray-dark">
                チームビルディング
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                定期的な社内イベントや懇親会を通じて、部署を超えた
                コミュニケーションを促進。働きやすい職場環境づくりに努めています。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Business;
